export default "__VITE_ASSET__3498e7ab__"